import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import InventoryQuantity from '@square/dashboard-items-data/models/squareup/inventory/v3/inventory-quantity';
import InventoryState from '@square/dashboard-items-data/models/squareup/inventory/v3/inventory-state';
import ProductIdentifier from '@square/dashboard-items-data/models/squareup/inventory/v3/product-identifier';
export default ProtoBaseModel.extend({
  productIdentifier: attr(ProductIdentifier),
  state: attr(InventoryState),
  quantity: attr(InventoryQuantity),
  quantityDecimal: attr(String),
  countedAt: attr(Number),
  countedBy: attr(String)
});